import { pressItems } from "@/mocks/press";

const formatDate = (value: string) =>
  new Date(value).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

export default function PressGrid() {
  return (
    <section id="press" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 font-label text-[11px] tracking-[0.3em] uppercase text-primary-500">
              <span className="w-6 h-px bg-primary-500" />
              In the Headlines
            </span>
            <h2 className="mt-3 font-heading font-extrabold uppercase tracking-tight text-foreground-950 text-3xl md:text-5xl">
              Press
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
              The latest news on our slate, acquisitions and global sales activity.
            </p>
          </div>
          <a
            href="#press"
            className="inline-flex items-center gap-2 rounded-md border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label text-xs tracking-[0.18em] uppercase px-5 py-3.5 whitespace-nowrap transition-colors cursor-pointer"
          >
            All Press
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pressItems.map((item) => (
            <a
              key={item.id}
              href="#press"
              className="group block rounded-lg bg-background-50 overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-foreground-900">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute top-3 left-3 rounded-full bg-background-50/95 px-3 py-1 font-label text-[10px] tracking-[0.16em] uppercase text-foreground-800">
                  {item.source}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs text-foreground-500">
                  {formatDate(item.date)}
                </p>
                <h3 className="mt-2 font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors line-clamp-3">
                  {item.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-1.5 font-label text-[11px] tracking-[0.16em] uppercase text-primary-500">
                  Read More
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}